import React from 'react'
import {Icon} from '@chakra-ui/react'

const ChevronUp = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props} data-testid="chevron-up" aria-hidden="true">
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 27.0133C5 26.8213 5.0735 26.6293 5.219 26.4823L19.4688 12.2205C19.6098 12.0795 19.8003 12 19.9998 12C20.1993 12 20.3898 12.0795 20.5308 12.2205L34.7806 26.4823C35.0731 26.7763 35.0731 27.2503 34.7806 27.5443C34.4866 27.8368 34.0126 27.8368 33.7186 27.5443L19.9998 13.8105L6.28098 27.5443C5.98699 27.8368 5.51299 27.8368 5.219 27.5443C5.0735 27.3973 5 27.2053 5 27.0133Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ChevronUp
